/**
 * Resolve which Users admin view to show from the URL pathname.
 */

export function getHubUsersView(pathname) {
  if (pathname === '/hub/settings/users/invite') {
    return { view: 'invite' }
  }
  if (pathname === '/hub/settings/users/new') {
    return { view: 'create' }
  }
  const editMatch = pathname.match(/^\/hub\/settings\/users\/(\d+)$/)
  if (editMatch) {
    return { view: 'edit', userId: editMatch[1] }
  }
  return { view: 'list' }
}

export function isHubUsersListPath(pathname) {
  return getHubUsersView(pathname).view === 'list'
}
